"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChatCompletionMessage = exports.postOpenaiChatCompletion = void 0;
var types_1 = require("@cdo/apps/aiTutor/types");
var HttpClient_1 = __importDefault(require("@cdo/apps/util/HttpClient"));
var constants_1 = require("./constants");
var Lab2Registry_1 = __importDefault(require("../lab2/Lab2Registry"));
/**
 * This function sends a POST request to the chat completion backend controller.
 */
function postOpenaiChatCompletion(messagesToSend, levelId) {
    return __awaiter(this, void 0, Promise, function () {
        var payload, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = levelId
                        ? { levelId: levelId, messages: messagesToSend }
                        : { messages: messagesToSend };
                    return [4 /*yield*/, HttpClient_1.default.post(constants_1.CHAT_COMPLETION_URL, JSON.stringify(payload), true, {
                            'Content-Type': 'application/json; charset=UTF-8',
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3: return [2 /*return*/, null];
            }
        });
    });
}
exports.postOpenaiChatCompletion = postOpenaiChatCompletion;
var formatForChatCompletion = function (chatMessages) {
    return chatMessages.map(function (message) {
        return { role: message.role, content: message.chatMessageText };
    });
};
/**
 * This function formats chat completion messages including the system prompt, passes them
 * to `postOpenaiChatCompletion`, then returns the status of the response and assistant message if successful.
 */
function getChatCompletionMessage(systemPrompt, userMessageId, newMessage, chatMessages) {
    return __awaiter(this, void 0, Promise, function () {
        var messagesToSend, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    messagesToSend = __spreadArray(__spreadArray([
                        { role: types_1.Role.SYSTEM, content: systemPrompt }
                    ], formatForChatCompletion(chatMessages), true), [
                        { role: types_1.Role.USER, content: newMessage },
                    ], false);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, postOpenaiChatCompletion(messagesToSend)];
                case 2:
                    response = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    Lab2Registry_1.default.getInstance()
                        .getMetricsReporter()
                        .logError('Error in chat completion request', error_1);
                    return [3 /*break*/, 4];
                case 4:
                    // For now, response will be null if there was an error.
                    if (!response) {
                        return [2 /*return*/, { status: types_1.Status.ERROR, id: userMessageId }];
                    }
                    else if (response.status === types_1.Status.PROFANITY) {
                        return [2 /*return*/, {
                                status: types_1.Status.PROFANITY,
                                id: userMessageId,
                                assistantResponse: "I can't respond because your message is inappropriate. Please don't use profanity.",
                            }];
                    }
                    else if (response && response.status && types_1.PII.includes(response.status)) {
                        return [2 /*return*/, {
                                status: types_1.Status.PERSONAL,
                                id: userMessageId,
                                assistantResponse: "I can't respond because your message is inappropriate. Please don't include personal information like your ".concat(response.status, "."),
                            }];
                    }
                    return [2 /*return*/, {
                            status: types_1.Status.OK,
                            id: userMessageId,
                            assistantResponse: response.content,
                        }];
            }
        });
    });
}
exports.getChatCompletionMessage = getChatCompletionMessage;
